import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { isNonEmptyVariable } from "@/util/common_function";
import { Button, Form } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";

export const MODE = { NEW: "NEW", EDIT: "EDIT" };

const MedicalInfoModal = ({
  show,
  handleCancel,
  formSubmit,
  selectMedicalInfo = null,
  bookingsFieldsEnabled = true
}) => {
  const [form] = useForm();
  console.log({ selectMedicalInfo })
  useEffect(() => {
    if (isNonEmptyVariable(selectMedicalInfo)) {
      console.log("inside if")
      form.setFieldsValue(selectMedicalInfo);
    } else {

      form.resetFields();
    }
  }, [selectMedicalInfo]);
  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        serviceDate: isNonEmptyVariable(values?.serviceDate)
          ? values?.serviceDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();

    });
  };
  function handleFormCancel() {
    handleCancel()
    form.resetFields();
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectMedicalInfo ? "VIEW" : "ADD"} Medical Information`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="60%"
        footerActions={[
          <Button key="SUBMIT" onClick={handleFormCancel} disabled={!bookingsFieldsEnabled}>
            Close
          </Button>,
          <Button key="SUBMIT" onClick={handleSubmit} disabled={!bookingsFieldsEnabled}>
            Submit
          </Button>
        ]
        }
      >
        <Form form={form} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={12}>
              <FormItem name="medicalRecord" label="Medical Record">
                <TextField name="medicalRecord" id="medicalRecord" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={12}>
              <FormItem name="serviceDate" label="Service Date" >
                <CommonDatePicker
                  showTime={false}
                  format="MM/DD/YYYY"
                  name="serviceDate"
                  id="serviceDate"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow>
            <StyledGridCol span={24}>
              <FormItem name="comment" label="Comments">
                <TextField
                  inputType="textarea"
                  name="comment"
                  id="comment"
                  rows={3}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};

export default MedicalInfoModal;
